import { dispatchEvent } from 'redux-ruleset'

export const SEARCH_BANNER_DISPLAYED: 'listing/SEARCH_BANNER_DISPLAYED' =
  'listing/SEARCH_BANNER_DISPLAYED'
export const SEARCH_BANNER_CLICKED: 'listing/SEARCH_BANNER_CLICKED' =
  'listing/SEARCH_BANNER_CLICKED'

export const searchBannerDisplayed = (
  link: string,
  altText: string,
  searchTerm: string
) =>
  dispatchEvent({
    type: SEARCH_BANNER_DISPLAYED,
    meta: {},
    payload: { link: link, altText: altText, searchTerm: searchTerm }
  })

export const searchBannerClicked = (
  link: string,
  altText: string,
  searchTerm: string
) =>
  dispatchEvent({
    type: SEARCH_BANNER_CLICKED,
    meta: {},
    payload: { link: link, altText: altText, searchTerm: searchTerm }
  })

export type SearchBannerDisplayed = ReturnType<typeof searchBannerDisplayed>
export type SearchBannerClicked = ReturnType<typeof searchBannerClicked>
export type Event = SearchBannerDisplayed | SearchBannerClicked

declare global {
  interface RulesetDispatchEvents {
    'app/molecules/ProductList': Event
  }
}
